import {TBrandAlphabetLetter} from 'modules/brands/types';

export const BRANDS_TOP_CODE = 'top';
export const BRANDS_ALL_CODE = 'all';
export const BRANDS_CYRILLIC_CODE = 'ru';

export const CYRILLIC_CODE_REGEXP = /\p{sc=Cyrillic}/gu;

export const BRANDS_CODE_FROM_PATH = /\/brands\/(?<brandCode>.*)(\/\w+)?/gu;

/* eslint-disable max-lines */
/* eslint-disable sort-keys  */
export const BRAND_X_PRODUCTS = [
    {
        id: 1,
        title: `Портвейн Graham's 20 Year Old Tawny Port в подарочной упаковке, Graham's`,
        article: '44444',
        rating: 4.2,
        images: [
            {
                type: 'image',
                url: 'https://static.simplewine.ru/upload/iblock/2cf/2cf8d508263434e291dd2b6d76e290f4.jpg',
                path: 'https://static.simplewine.ru/upload/iblock/2cf/2cf8d508263434e291dd2b6d76e290f4.jpg',
                alternative: 'Подпись к изображению',
            },
        ],
        price: {
            main: {
                price: 1490,
                currency: 'RUB',
                unit: 'кв. м',
                basePrice: 1590,
            },
            additional: [
                {
                    price: 1490,
                    currency: 'RUB',
                    unit: 'кв. м',
                },
                {
                    price: 1390,
                    currency: 'RUB',
                    unit: 'кв. м',
                },
            ],
            accounting: {
                price: 1490,
                currency: 'RUB',
                unit: 'кв. м',
                basePrice: 1590,
            },
            bonus: 500,
            extraBonus: 200,
        },
        nameplates: [
            {
                type: 'new',
                title: 'Новинка',
                id: 0,
                url: '/products/plt-a123/3d/',
                bgColor: '#FFC72C',
                textColor: '#1C1C1C',
            },
        ],
        availability: [
            {
                title: 'Доставка',
                type: 'store',
                availabilityCount: {
                    amount: 200,
                    unit: 'кв. м',
                    text: 'Доступно к заказу 10 шт',
                },
                prompt: {
                    title: 'Время сборки 2 часа в магазине в пределах остатков в наличии',
                    text: 'Время сборки',
                },
                stores: [
                    {
                        store: {
                            id: 324,
                            title: 'ул. Ленина, 50',
                            address: 'Московская область, г. Подольск, ул. Ленина, 50',
                            storeType: 'store',
                        },
                        planDate: '2023-06-15',
                        planDateText: 'Через 2 дня',
                        amount: 120,
                        unit: 'кв. м',
                        availText: '50 кв. м',
                        extra: 'string',
                        placements: ['Ряд 5, место 12'],
                        hint: 'Этот товар Вы можете купить только в магазине',
                    },
                ],
                availabilityDate: {
                    title: 'Магазины Москвы',
                    planDate: '2023-06-14',
                    planDateText: 'Завтра',
                    prompt: {
                        title: 'Время сборки 2 часа в магазине в пределах остатков в наличии',
                        text: 'Время сборки',
                    },
                },
            },
        ],
        code: 'keramicheskaya-plitka-delta-seriya-alfa',
    },
    {
        id: 11,
        title: 'Вино Pouilly-Fume En Travertin, Henri Bourgeois, 2022 г.',
        article: '78901234',
        rating: 4.5,
        images: [
            {
                type: 'image',
                title: 'Подпись к изображению',
                path: 'https://static.simplewine.ru/upload/iblock/d9f/d9f392ea2d0a489d7abf316f41ed38f0.jpg@x248',
                alternative: 'Подпись к изображению',
            },
            {
                type: 'image',
                title: 'Подпись к изображению',
                path: 'https://static.simplewine.ru/upload/iblock/d9f/d9f392ea2d0a489d7abf316f41ed38f0.jpg@x248',
                alternative: 'Подпись к изображению',
            },
        ],
        price: {
            main: {
                price: 2500,
                currency: 'RUB',
                unit: 'шт',
                basePrice: 3000,
            },
            additional: [
                {
                    price: 2500,
                    currency: 'RUB',
                    unit: 'шт',
                },
            ],
            accounting: {
                price: 2500,
                currency: 'RUB',
                unit: 'шт',
                basePrice: 3000,
            },
            bonus: 500,
            extraBonus: 500,
        },
        nameplates: [
            {
                type: 'new',
                title: 'Новинка',
                id: 1,
                url: '/products/brush-set-123/new/',
                bgColor: '#FF0000',
                textColor: '#FFFFFF',
            },
        ],
        availability: [
            {
                title: 'Доставка',
                type: 'store',
                availabilityCount: {
                    amount: 200,
                    unit: 'кв. м',
                    text: 'Доступно к заказу 10 шт',
                },
                prompt: {
                    title: 'Время сборки 2 часа в магазине в пределах остатков в наличии',
                    text: 'Время сборки',
                },
                stores: [
                    {
                        store: {
                            id: 324,
                            title: 'ул. Ленина, 50',
                            address: 'Московская область, г. Подольск, ул. Ленина, 50',
                            storeType: 'store',
                        },
                        planDate: '2023-06-15',
                        planDateText: 'Через 2 дня',
                        amount: 120,
                        unit: 'кв. м',
                        availText: '50 кв. м',
                        extra: 'string',
                        placements: ['Ряд 5, место 12'],
                        hint: 'Этот товар Вы можете купить только в магазине',
                    },
                ],
                availabilityDate: {
                    title: 'Магазины Москвы',
                    planDate: '2023-06-14',
                    planDateText: 'Завтра',
                    prompt: {
                        title: 'Время сборки 2 часа в магазине в пределах остатков в наличии',
                        text: 'Время сборки',
                    },
                },
            },
        ],
        code: 'nabor-kistey-dlya-zhivopisi',
    },
    {
        id: 173,
        title: `Портвейн Graham's 20 Year Old Tawny Port в подарочной упаковке, Graham's`,
        article: '44444',
        rating: 4.2,
        images: [
            {
                type: 'image',
                url: 'https://static.simplewine.ru/upload/iblock/2cf/2cf8d508263434e291dd2b6d76e290f4.jpg',
                path: 'https://static.simplewine.ru/upload/iblock/2cf/2cf8d508263434e291dd2b6d76e290f4.jpg',
                alternative: 'Подпись к изображению',
            },
        ],
        price: {
            main: {
                price: 1490,
                currency: 'RUB',
                unit: 'кв. м',
                basePrice: 1590,
            },
            additional: [
                {
                    price: 1490,
                    currency: 'RUB',
                    unit: 'кв. м',
                },
                {
                    price: 1390,
                    currency: 'RUB',
                    unit: 'кв. м',
                },
            ],
            accounting: {
                price: 1490,
                currency: 'RUB',
                unit: 'кв. м',
                basePrice: 1590,
            },
            bonus: 500,
            extraBonus: 200,
        },
        nameplates: [
            {
                type: 'new',
                title: 'Новинка',
                id: 0,
                url: '/products/plt-a123/3d/',
                bgColor: '#FFC72C',
                textColor: '#1C1C1C',
            },
        ],
        availability: [
            {
                title: 'Доставка',
                type: 'store',
                availabilityCount: {
                    amount: 200,
                    unit: 'кв. м',
                    text: 'Доступно к заказу 10 шт',
                },
                prompt: {
                    title: 'Время сборки 2 часа в магазине в пределах остатков в наличии',
                    text: 'Время сборки',
                },
                stores: [
                    {
                        store: {
                            id: 324,
                            title: 'ул. Ленина, 50',
                            address: 'Московская область, г. Подольск, ул. Ленина, 50',
                            storeType: 'store',
                        },
                        planDate: '2023-06-15',
                        planDateText: 'Через 2 дня',
                        amount: 120,
                        unit: 'кв. м',
                        availText: '50 кв. м',
                        extra: 'string',
                        placements: ['Ряд 5, место 12'],
                        hint: 'Этот товар Вы можете купить только в магазине',
                    },
                ],
                availabilityDate: {
                    title: 'Магазины Москвы',
                    planDate: '2023-06-14',
                    planDateText: 'Завтра',
                    prompt: {
                        title: 'Время сборки 2 часа в магазине в пределах остатков в наличии',
                        text: 'Время сборки',
                    },
                },
            },
        ],
        code: 'keramicheskaya-plitka-delta-seriya-alfa',
    },
    {
        id: 11435,
        title: 'Вино Pouilly-Fume En Travertin, Henri Bourgeois, 2022 г.',
        article: '78901234',
        rating: 4.5,
        images: [
            {
                type: 'image',
                title: 'Подпись к изображению',
                path: 'https://static.simplewine.ru/upload/iblock/d9f/d9f392ea2d0a489d7abf316f41ed38f0.jpg@x248',
                alternative: 'Подпись к изображению',
            },
            {
                type: 'image',
                title: 'Подпись к изображению',
                path: 'https://static.simplewine.ru/upload/iblock/d9f/d9f392ea2d0a489d7abf316f41ed38f0.jpg@x248',
                alternative: 'Подпись к изображению',
            },
        ],
        price: {
            main: {
                price: 2500,
                currency: 'RUB',
                unit: 'шт',
                basePrice: 3000,
            },
            additional: [
                {
                    price: 2500,
                    currency: 'RUB',
                    unit: 'шт',
                },
            ],
            accounting: {
                price: 2500,
                currency: 'RUB',
                unit: 'шт',
                basePrice: 3000,
            },
            bonus: 500,
            extraBonus: 500,
        },
        nameplates: [
            {
                type: 'new',
                title: 'Новинка',
                id: 1,
                url: '/products/brush-set-123/new/',
                bgColor: '#FF0000',
                textColor: '#FFFFFF',
            },
        ],
        availability: [
            {
                title: 'Доставка',
                type: 'store',
                availabilityCount: {
                    amount: 200,
                    unit: 'кв. м',
                    text: 'Доступно к заказу 10 шт',
                },
                prompt: {
                    title: 'Время сборки 2 часа в магазине в пределах остатков в наличии',
                    text: 'Время сборки',
                },
                stores: [
                    {
                        store: {
                            id: 324,
                            title: 'ул. Ленина, 50',
                            address: 'Московская область, г. Подольск, ул. Ленина, 50',
                            storeType: 'store',
                        },
                        planDate: '2023-06-15',
                        planDateText: 'Через 2 дня',
                        amount: 120,
                        unit: 'кв. м',
                        availText: '50 кв. м',
                        extra: 'string',
                        placements: ['Ряд 5, место 12'],
                        hint: 'Этот товар Вы можете купить только в магазине',
                    },
                ],
                availabilityDate: {
                    title: 'Магазины Москвы',
                    planDate: '2023-06-14',
                    planDateText: 'Завтра',
                    prompt: {
                        title: 'Время сборки 2 часа в магазине в пределах остатков в наличии',
                        text: 'Время сборки',
                    },
                },
            },
        ],
        code: 'nabor-kistey-dlya-zhivopisi',
    },
];

export const BRAND_X = {
    banner: 'https://simplewine.ru/upload/iblock/535/53591fa1851c8244629372a364f9d74b.jpg',
    description:
        'La Scolca — культовое итальянское хозяйство, которое было основано более 100 лет назад семьей Сольдати. Это один из старейших семейных домов в коммуне Гави. Визитная карточка винодельни — статусное белое вино Gavi dei Gavi Etichetta Nera, «Черная этикетка» с 60-летних лоз. Вина La Scolca представлены в винных картах лучших ресторанов Лазурного берега и других престижных курортов мира. Их подают на нобелевских и оскаровских вечеринках и закупают для звездных банкетов (например, Том Круз для своей свадьбы).',
    logo: {
        src: 'https://static.simplewine.ru/upload/iblock/bad/bad8196245a7e0f084058916ef4b7663.png@215',
        srcSet: 'https://static.simplewine.ru/upload/iblock/bad/bad8196245a7e0f084058916ef4b7663.png@430',
    },
    title: 'La Scolca',
    videoLink: 'https://www.youtube.com/embed/RnKmkn5HeBU?enablejsapi=1',
};

export const BRAND_ALPHABET: TBrandAlphabetLetter[] = [
    {
        filteredCode: BRANDS_TOP_CODE,
        href: 'brands_top',
        label: 'Топ-бренды',
    },
    {
        filteredCode: 'a',
        href: 'brand_a',
        label: 'A',
    },
    {
        filteredCode: 'b',
        href: 'brand_b',
        label: 'B',
    },
    {
        filteredCode: 'c',
        href: 'brand_c',
        label: 'C',
    },
    {
        filteredCode: 'd',
        href: 'brand_d',
        label: 'D',
    },
    {
        filteredCode: 'e',
        href: 'brand_e',
        label: 'E',
    },
    {
        filteredCode: 'f',
        href: 'brand_f',
        label: 'F',
    },
    {
        filteredCode: 'g',
        href: 'brand_g',
        label: 'G',
    },
    {
        filteredCode: 'h',
        href: 'brand_h',
        label: 'H',
    },
    {
        filteredCode: 'i',
        href: 'brand_i',
        label: 'I',
    },
    {
        filteredCode: 'j',
        href: 'brand_j',
        label: 'J',
    },
    {
        filteredCode: 'l',
        href: 'brand_l',
        label: 'L',
    },
    {
        filteredCode: 'm',
        href: 'brand_m',
        label: 'M',
    },
    {
        filteredCode: 'n',
        href: 'brand_n',
        label: 'N',
    },
    {
        filteredCode: 'o',
        href: 'brand_o',
        label: 'O',
    },
    {
        filteredCode: 'p',
        href: 'brand_p',
        label: 'P',
    },
    {
        filteredCode: 'q',
        href: 'brand_q',
        label: 'Q',
    },
    {
        filteredCode: 'r',
        href: 'brand_r',
        label: 'R',
    },
    {
        filteredCode: 's',
        href: 'brand_s',
        label: 'S',
    },
    {
        filteredCode: 't',
        href: 'brand_t',
        label: 'T',
    },
    {
        filteredCode: 'v',
        href: 'brand_v',
        label: 'V',
    },
    {
        filteredCode: 'w',
        href: 'brand_w',
        label: 'W',
    },
    {
        filteredCode: 'y',
        href: 'brand_y',
        label: 'Y',
    },
    {
        filteredCode: 'z',
        href: 'brand_z',
        label: 'Z',
    },
    {
        filteredCode: BRANDS_CYRILLIC_CODE,
        href: 'brand_aya',
        label: 'А-Я',
    },
    {
        filteredCode: BRANDS_ALL_CODE,
        href: 'brand_all',
        label: 'Все',
    },
];
